import { EndpointError } from '@square/ignition';
import { NativeButton } from '@squareup/dex-ui';
import { Box } from '@squareup/dex-ui-shared-base';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';

import { ErrorContent } from '../../ErrorContent';
import { ErrorInfo } from '../../ErrorInfo';

import styles from './error-row.module.css';

interface ErrorRowProps {
  compact?: boolean;
  errorProperty: EndpointError;
  changeRow(errorProperty: EndpointError): void;
  selectedErrorRow: EndpointError;
}

const ErrorRow: FunctionComponent<ErrorRowProps> = ({
  compact = false,
  errorProperty,
  changeRow,
  selectedErrorRow,
}) => {
  const className = clsx(compact ? styles['one-column'] : styles['two-column']);

  return (
    <Box
      border={{ radius: '12' }}
      padding={{ bottom: '2x', left: '3x', right: '3x', top: '2x' }}
      className={clsx(
        styles.outer,
        selectedErrorRow.name === errorProperty.name && styles.active
      )}
      role="link"
    >
      <NativeButton
        trackingId={`error-row-clicked-${errorProperty.name}}`}
        className={clsx(styles['error-row'], className)}
        omitFocus={true}
        onClick={() => changeRow(errorProperty)}
      >
        <ErrorInfo errorProperty={errorProperty}></ErrorInfo>
        <ErrorContent errorProperty={errorProperty}></ErrorContent>
      </NativeButton>
    </Box>
  );
};
export { ErrorRow };
